import { QueryType, SelectOption } from "../models";
import { useAccountQuery, useAccountTypeQuery } from "../queries";

interface IUseAccountSelectOptions {
    options: SelectOption[];
    accountTypeId: string;
    isLoading: boolean;
}

export const useAccountSelectOptions = (
    accountTypeName: string,
    phoneNumber?: string,
    idAsString = true
): IUseAccountSelectOptions => {
    const {
        listQuery: { data: accountTypes, isFetching: isAccountTypesFetching },
    } = useAccountTypeQuery({ queryType: QueryType.List });

    const accountType = accountTypes?.find((type) => type.name === accountTypeName);

    const {
        listQuery: { data: accounts, isFetching: isAccountsFetching },
    } = useAccountQuery({ queryType: QueryType.List, accountTypeId: accountType?.id.toString(), phoneNumber });

    const accountOptions = accounts?.map((account) => ({
        label: account.name,
        value: idAsString ? account.id.toString() : account.id,
    }));

    return {
        options: accountOptions ?? [],
        accountTypeId: accountType?.id.toString() ?? "",
        isLoading: isAccountTypesFetching || isAccountsFetching,
    };
};
